function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import axios from "axios";
/**
 * Creates the Axios Instance for the HTTP Client.
 * @param {HttpClientArgs} args - The arguments to create the Instance.
 * @returns {AxiosInstance} A new Axios Instance assigned to the HTTP Client.
 */ export function createAxiosInstance(param) {
    var apiName = param.apiName, clientName = param.clientName, baseUrl = param.baseUrl, userAgent = param.userAgent, _param_headers = param.headers, headers = _param_headers === void 0 ? {} : _param_headers, _param_options = param.options, options = _param_options === void 0 ? {} : _param_options;
    if (!apiName) throw new Error("apiName is required");
    if (!clientName) throw new Error("clientName is required");
    var instanceHeaders = _extends({
        accept: "application/json",
        "Content-Type": "application/json",
        "x-lll-client": clientName
    }, headers);
    /**
   * Only add user-agent to the headers if we are in a Node.js environment.
   * The browser should send its own user-agent.
   */ if (typeof window === "undefined" && userAgent) {
        instanceHeaders["user-agent"] = "lululemon/" + userAgent;
    }
    return axios.create({
        baseURL: baseUrl,
        headers: instanceHeaders,
        timeout: options.timeout
    });
}
